// Converts an object to a query string
export default function objectToQueryString(obj: Record<string, any>): string {
  const queryStr = new URLSearchParams(obj).toString();
  return queryStr ? `?${queryStr}` : '';
}
